import { ReactNode } from 'react';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { AnnouncementBanner } from './AnnouncementBanner';

/**
 * App-root wrapper that renders the live announcement banner above the app
 * layout, then the rest of the app.
 */
export const AnnouncementBannerWrapper = ({
  children,
}: {
  children: ReactNode;
}) => (
  <>
    <AnnouncementBanner />
    {children}
  </>
);

/**
 * Renders the live announcement banner at the top of the app root.
 *
 * NOTE: In the legacy app the banner sat to the right of the sidebar,
 * wrapping only the page content. The new frontend system exposes
 * `AppRootWrapperBlueprint`, which wraps the entire app root (sidebar
 * included). The banner therefore renders above the whole layout rather
 * than only above the page content. This is the closest app-level hook
 * available in this phase.
 */
export const announcementBannerExtension = AppRootWrapperBlueprint.make({
  name: 'announcement-banner',
  params: {
    component: AnnouncementBannerWrapper,
  },
});
